import { Box, Button, Container, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import Page from "../pages/Page";
import girl from '../assets/Illustrations/girl.png'
import { m } from 'framer-motion';
import { display } from "@mui/system";
const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));
// ✅ Define functional component outside the class
export const ErrorPage = ({ message }) => {
//   const navigate = useNavigate();
  const theme = useTheme();
const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page sx={{ height: 1, minHeight: '100vh',display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center', marginTop: '-2rem' }}>
            <m.div>
              <Typography variant="h5" paragraph>
               Something Went Wrong
              </Typography>
            </m.div>
            <Typography sx={{ color: 'text.secondary' }}>
             We’re sorry, but something went wrong on our end. Please try again later or go back to the {isSm ? 'home screen' : 'home page'}.
            </Typography>

            <m.div>
             <img src={girl} alt="Girl " style={{height:'400px',width:'auto'}}/>
            </m.div>
            <Button onClick={() =>{ isSm ? window.location.href = '/home/announcement/gnn' : window.location.href = '/home/announcement/gnn/';}} size="large" variant="contained">
              Go to Home
            </Button>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
};
